import { render, staticRenderFns } from "./jzxz.vue?vue&type=template&id=230e7f14&scoped=true&"
import script from "./jzxz.vue?vue&type=script&lang=js&"
export * from "./jzxz.vue?vue&type=script&lang=js&"
import style0 from "./jzxz.vue?vue&type=style&index=0&id=230e7f14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230e7f14",
  null
  
)

export default component.exports